(() => {
  const selectors = {
    hours: ".sell-banner__timer--hours",
    mins: ".sell-banner__timer--min",
    seconds: ".sell-banner__timer--seconds",
    timer: ".sell-banner__timer",
  };

  document.querySelectorAll(selectors.timer).forEach((item) => {
    const settingsHours = +item.dataset.hours;
    const settingsMins = +item.dataset.mins;

    let countdownDate = new Date();
    countdownDate.setHours(settingsHours, settingsMins, 0, 0);
    countdownDate.setDate(countdownDate.getDate());

    const elHours = item.querySelector(selectors.hours);
    const elMins = item.querySelector(selectors.mins);
    const elSeconds = item.querySelector(selectors.seconds);

    const updateCountdown = () => {
      const now = new Date().getTime();
      const isNextDay = countdownDate - now < 0;
      const nextDay = new Date();

      nextDay.setHours(settingsHours, settingsMins, 0, 0);
      nextDay.setDate(nextDay.getDate() + 1);

      const distance = isNextDay ? nextDay - now : countdownDate - now;

      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );

      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      elHours.textContent = hours;
      elMins.textContent = minutes;
      elSeconds.textContent = seconds;
    };

    const interval = setInterval(updateCountdown, 1000);
    updateCountdown();
  });
})();
